/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

import { pushRouterToChatWithMember } from 'lib/ChatRouteHelper';
import Button from 'components/ButtonDeprecated';
import Glyph from 'components/Glyph';
import Group from 'entities/Group';
import ToastActions from 'actions/ToastActions';

import type { NamedInterlocutor } from 'lib/ChatRouteHelper';

export class StartChatButton extends React.Component<{
  subscriber: NamedInterlocutor,
  useGlyph?: ?boolean,
  onRequestHide?: ?Function,
  children?: React.Node,
  disabled?: boolean,
  text?: string,
}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    group: PropTypes.instanceOf(Group),
  };

  static defaultProps = {
    text: 'Send a message',
  };

  startChat = () => {
    const { group, router } = this.context;
    if (this.props.disabled) {
      return;
    }

    const subscriber: NamedInterlocutor = this.props.subscriber;

    pushRouterToChatWithMember(router, subscriber, group, () =>
      ToastActions.showErrorToast('Oops! We weren’t able to load that chat. Please try again.')
    );
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };
  render() {
    const { useGlyph, children, text, ...other } = this.props;

    if (children) {
      return <div onClick={this.startChat}>{children}</div>;
    }

    if (useGlyph) {
      return (
        <Button
          {...other}
          aria-label="Send a message"
          size="xsmall"
          level="icon"
          tooltip="Send a message"
          tooltipPlacement="bottom"
          onClick={this.startChat}>
          <Glyph name="chat-add-bubble" size="xlarge" solo />
        </Button>
      );
    } else {
      return (
        <Button size="xsmall" {...other} onClick={this.startChat}>
          {text}
        </Button>
      );
    }
  }
}

export default StartChatButton;
